 import React from 'react';
 import CourseStep from '../course-step'
 import ProfileStep from '../profile-step'
 import Button from '@material-ui/core/Button';
 import SendIcon from '@material-ui/icons/Send';
 import Typography from '@material-ui/core/Typography';
 import { ValidatorForm, TextValidator,SelectValidator} from 'react-material-ui-form-validator';

 export default(props)=>{
   const {classes,handleBack,handleSubmit}=props
   return(
     <ValidatorForm
onSubmit={handleSubmit}
     >
     <Typography variant="h6" gutterBottom>
      Course Details
      </Typography>
     <CourseStep {...props} direct_call/>
     <br />
     <Typography variant="h6" gutterBottom>
      Profile
      </Typography>
        <ProfileStep {...props} direct_call/>



        <br />

           <div className={classes.buttons}>
           <Button type="button"  className={classes.button} onClick={handleBack}    color="primary"  >
                 PREV
               </Button>
        <Button type="submit"   className={classes.button}    variant="contained" color="secondary"  endIcon={<SendIcon/>}>
              SUBMIT

            </Button>
</div>

        </ValidatorForm>


   )
 }
